var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F22",
    d: "M13 17.125a4.375 4.375 0 1 1 0-8.75 4.375 4.375 0 0 1 0 8.75M13 .5A12.25 12.25 0 0 0 .75 12.75C.75 21.938 13 35.5 13 35.5s12.25-13.562 12.25-22.75A12.25 12.25 0 0 0 13 .5"
  })));
};
export default SvgLocation;